import { render, staticRenderFns } from "./momentsEditDialog.vue?vue&type=template&id=42f06c5c&scoped=true"
import script from "./momentsEditDialog.vue?vue&type=script&lang=js"
export * from "./momentsEditDialog.vue?vue&type=script&lang=js"
import style0 from "./momentsEditDialog.vue?vue&type=style&index=0&id=42f06c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f06c5c",
  null
  
)

export default component.exports